module.exports = __webpack_public_path__ + "img/guitar.db5c72dc.jpg";